<template>
	<section class="page page-map">
		<SceneMap />
	</section>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import PageBase from '@/Core/Page.vue';
	import { Component, Prop, Ref, Watch, Vue } from 'vue-property-decorator';
	import { beforeDestroy, event, mounted } from '@/Utility/Decorators';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package Page
	 * @project ChalkySticks App
	 */
	@Component
	export default class PageMap extends PageBase {
		// Not implemented
	}
</script>
